import React, { Component } from 'react'
import { DatePicker } from 'antd';
import moment from 'moment';

const STATUS_DATA = {
    1: 'Đang chờ điều xe',
    2: 'Đã điều xe',
    3: 'Đang diễn ra',
    4: 'Đã hoàn thành',
    5: 'Đã hủy',
    6: 'Đã cho mượn xe',
    7: 'Đang cho mượn tài',
    8: 'Đang cho mượn xe và tài'
}

export class DriverlessShortInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            from: moment().startOf('month'),
            end: moment()
        }
    }

    getStatus = contract => {
        if (contract.driver_is_transferred_another === false && contract.vehicle_is_transferred_another === false) {
            return contract.status;
        } else if (contract.driver_is_transferred_another === true && contract.vehicle_is_transferred_another === false) {
            return 7;
        } else if (contract.driver_is_transferred_another === false && contract.vehicle_is_transferred_another === true) {
            return 6;
        } else if (contract.driver_is_transferred_another === true && contract.vehicle_is_transferred_another === true) {
            return 8;
        }

        return contract.status;
    }

    onChangeDateLocal = (date) => {
        const currentTimes = moment().valueOf();
        const nowTimes = moment().endOf('day').valueOf();
        const { from_datetime, to_datetime } = this.props.contractData;

        const start = moment(date).startOf('month');
        const endtime = moment(date).endOf('month');

        let timeFromChoose = start;
        let timeToChoose = endtime;
        if (start.valueOf() < from_datetime) {
            timeFromChoose = moment(from_datetime);
        } else {
            timeFromChoose = start;
        }

        if (endtime.valueOf() > to_datetime) {
            timeToChoose = moment(to_datetime);
        } else {
            if (currentTimes > endtime.valueOf()) {
                timeToChoose = endtime;
            } else {
                timeToChoose = moment();
            }
        }
        this.setState({
            from: timeFromChoose,
            end: timeToChoose
        })
        this.props.onChangeDate(timeFromChoose.valueOf(), timeToChoose.valueOf())
    }

    render() {
        const { contractData, laybelData } = this.props;
        const { from, end } = this.state;
        const { branch, vehicle_working_area, code, customer, status, term, driver, vehicle, working_time_from, working_time_to, working_time_weekend_holiday_from, working_time_weekend_holiday_to, from_datetime, to_datetime, member_customer } = contractData;

        const columnData1 = [
            {
                name: 'Mã hợp đồng',
                value: code
            },
            {
                name: 'Khách hàng',
                value: customer ? customer.name : ''
            },
            {
                name: 'Admin',
                value: member_customer ? member_customer.name : ''
            },
            {
                name: 'Trạng thái',
                value: STATUS_DATA[this.getStatus(contractData)]
            },
            {
                name: 'Kỳ hạn hợp đồng',
                value: `${term} tháng`
            }
        ]
        const columnData2 = [
            {
                name: 'Thời hạn hợp đồng',
                value: `${moment(from_datetime).format('DD/MM/YYYY')} - ${moment(to_datetime).format('DD/MM/YYYY')}`
            },
            {
                name: 'Tài xế',
                value: driver ? driver.name : ''
            },
            {
                name: 'Biển KS',
                value: vehicle ? vehicle.number_plate : ''
            },
            {
                name: 'Số ngày trong tháng',
                value: moment(from).endOf('month').format('DD')
            },
            {
                name: 'Ngày đầu tiên phục vụ',
                value: moment(from_datetime).format('DD/MM/YYYY')
            },
        ]

        return <div className="driverless-short-info">
            <div className="left">
                <div className="range-date">
                    <div className="date-container">
                        <span style={{ marginRight: 7 }}>* Bắt đầu từ</span>
                        <DatePicker
                            value={from}
                            // inputReadOnly
                            clearIcon={false}
                            onChange={date => this.onChangeDateLocal(date)}
                            className="date-picker"
                            disabledDate={currentDate => {
                                const currentTimes = currentDate.valueOf();
                                const nowTimes = moment().endOf('day').valueOf();
                                if (to_datetime > nowTimes) {
                                    if (currentTimes >= from_datetime && currentTimes < nowTimes) {
                                        return false;
                                    }
                                    return true;
                                } else {
                                    if (currentTimes >= from_datetime && currentTimes <= to_datetime) {
                                        return false;
                                    }
                                    return true;
                                }

                            }}
                            //dropdownClassName="date-picker-dropdown-top"
                            getPopupContainer={node => {
                                if (node) {
                                    return node.parentNode;
                                }
                                return document.body;
                            }} format='DD/MM/YYYY' />
                    </div>
                    <div style={{ marginTop: 7 }} className="date-container">
                        <span style={{ marginRight: 7 }}>* Đến</span>
                        <DatePicker
                            value={end}
                            clearIcon={false}
                            // inputReadOnly
                            onChange={date => this.onChangeDateLocal(date)}
                            disabledDate={currentDate => {
                                const currentTimes = currentDate.valueOf();
                                const nowTimes = moment().endOf('day').valueOf();
                                if (to_datetime > nowTimes) {
                                    if (currentTimes >= from_datetime && currentTimes < nowTimes) {
                                        return false;
                                    }
                                    return true;
                                } else {
                                    if (currentTimes >= from_datetime && currentTimes <= to_datetime) {
                                        return false;
                                    }
                                    return true;
                                }
                            }}
                            className="date-picker"
                            //dropdownClassName="date-picker-dropdown-top"
                            getPopupContainer={node => {
                                if (node) {
                                    return node.parentNode;
                                }
                                return document.body;
                            }} format='DD/MM/YYYY' />
                    </div>
                </div>
                <div className="text-info">
                    <div className="circle" />
            Chi nhánh quản lý xe: {branch.code}
                </div>
                <div className="text-info">
                    <div className="circle" />
            Khu vực xe chạy: {vehicle_working_area}
                </div>
            </div>
            <div className="left">
                {columnData1.map(value => {
                    return <div key={value.name} className="text-info">
                        <div className="circle" />
                        {value.name}: {value.value}
                    </div>
                })}
            </div>
            <div className="left">
                {columnData2.map(value => {
                    return <div key={value.name} className="text-info">
                        <div className="circle" />
                        {value.name}: {value.value}
                    </div>
                })}
            </div>
        </div>
    }
}